import { AutogenModelTriumphpayFieldList, AutogenRowTriumphpayFieldList } from "./autogen/AutogenModelTriumphpayFieldList";

export class ModelTriumphpayFieldList extends AutogenModelTriumphpayFieldList<RowTriumphpayFieldList> {
	constructor() {
		super(RowTriumphpayFieldList);
	}
}

export class RowTriumphpayFieldList extends AutogenRowTriumphpayFieldList {
}